(function () {
	const header = () => {
		const headerMore = document.querySelector('.c-header__more');
		const headerClose = document.querySelector('.c-mobile-header__close');
		const headerPop = document.querySelector('.c-mobile-header__pop');
		const headerBtn = document.querySelectorAll('.c-mobile-header__btn');
		const headerBox = document.querySelectorAll('.c-mobile-header__box');

		if(headerMore) {
			headerMore.addEventListener('click', () => {
				headerPop.classList.toggle('c-mobile-header__pop--active');
				scrollSet.otherLenisScroll('.c-mobile-header__pop', true);
			})
			headerClose.addEventListener('click', () => {
				headerPop.classList.toggle('c-mobile-header__pop--active');
				scrollSet.otherLenisScroll('.c-mobile-header__pop', false);
			})
		}
		if(headerBtn) {
			headerBtn.forEach(btn => {
				const btnWrap = btn.closest('.c-mobile-header__wrap');
				const headerItem = btnWrap.querySelectorAll('.c-mobile-header__item');
				btn.addEventListener('click', () => {
					if(btn.classList.contains('c-mobile-header__btn--active')) {
						headerBtn.forEach(other => {
							const otherWrap = other.closest('.c-mobile-header__wrap');
							otherWrap.classList.remove('c-mobile-header__wrap--active');
							otherWrap.classList.remove('c-mobile-header__wrap--hide');
						})
						// headerItem.forEach(item => {
						// 	item.style.height = 0 + 'px';
						// })
						btn.classList.remove('c-mobile-header__btn--active');
					} else {
						headerBtn.forEach(other => {
							const otherWrap = other.closest('.c-mobile-header__wrap');
							otherWrap.classList.add('c-mobile-header__wrap--hide');
							otherWrap.classList.remove('c-mobile-header__wrap--active');
						})
						btnWrap.classList.remove('c-mobile-header__wrap--hide');
						btnWrap.classList.add('c-mobile-header__wrap--active');
						btn.classList.add('c-mobile-header__btn--active');
						// headerItem.forEach(item => {
						// 	item.style.height = item.scrollHeight + 'px';
						// })
					}
					
				});
			})
		}
		if(headerBox) {
			headerBox.forEach(btn => {
				btn.addEventListener('click', () => {
					const item = btn.closest('.c-mobile-header__item');
					const itemList = item.querySelector('.c-mobile-header__list');
					if(btn.classList.contains('c-mobile-header__box--active')) {
						itemList.style.height = 0 + 'px';
						itemList.classList.remove('c-mobile-header__list--active')
						btn.classList.remove('c-mobile-header__box--active');
					} else {
						console.log(itemList.scrollHeight)
						itemList.style.height = itemList.scrollHeight + 'px';
						itemList.classList.add('c-mobile-header__list--active')
						btn.classList.add('c-mobile-header__box--active');
					}
				})
			})
		}
	}

	document.addEventListener('shopify:section:load', header);
	header();
})();
